import React from 'react';
import icon from '../../../../../../assets/icons/charts/zoomAndFilter/icon_geo_chart.svg';
import SVG from "react-inlinesvg";

const IconGeoChart = () => (

    <SVG src={icon}  height={40} style = {{ marginTop: 10}} />

);
export default IconGeoChart;